import { useEffect, useState, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import {
  PublishedOrderGrid,
  BookOrderDrawer,
  SHEET_CLOSE_ANIMATION_MS,
} from '@hero/web-components';
import type { Order } from '@hero/schema';

export default function NewLoadsPage() {
  const { t } = useTranslation(['dashboard', 'm-order']);
  const { setPageName } = usePageContext();

  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [isBookDrawerOpen, setIsBookDrawerOpen] = useState(false);
  const clearOrderAfterCloseRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    setPageName(t('dashboard:NewLoads.title'));
  }, [setPageName, t]);

  useEffect(
    () => () => {
      if (clearOrderAfterCloseRef.current) {
        clearTimeout(clearOrderAfterCloseRef.current);
      }
    },
    [],
  );

  const handleOrderClick = useCallback((order: Order) => {
    if (clearOrderAfterCloseRef.current) {
      clearTimeout(clearOrderAfterCloseRef.current);
      clearOrderAfterCloseRef.current = null;
    }
    setSelectedOrder(order);
    setIsBookDrawerOpen(true);
  }, []);

  const handleCloseBook = useCallback(() => {
    setIsBookDrawerOpen(false);
    if (clearOrderAfterCloseRef.current) {
      clearTimeout(clearOrderAfterCloseRef.current);
    }
    clearOrderAfterCloseRef.current = setTimeout(() => {
      setSelectedOrder(null);
      clearOrderAfterCloseRef.current = null;
    }, SHEET_CLOSE_ANIMATION_MS);
  }, []);

  return (
    <>
      <div className="mt-6">
        <PublishedOrderGrid onOrderClick={handleOrderClick} />
      </div>

      <BookOrderDrawer order={selectedOrder} isOpen={isBookDrawerOpen} onClose={handleCloseBook} />
    </>
  );
}
